import { Container, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Provider from './containers/Provider';
import Providers from './containers/Providers';
import favoriteItemsContext from './contexts/favoriteItems';
import providersContext from './contexts/providers';
import withDisplayData from './hocs/withDisplayData';
import withFavoriteItems from './hocs/withFavoriteItems';
import withProviders from './hocs/withProviders';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    paddingBottom: 20,
    width: '100%',
    '@media (min-width: 796px)': {
      maxWidth: '768px',
    },
    '@media (min-width: 976px)': {
      maxWidth: '876px',
    },
    '@media (min-width: 1180px)': {
      maxWidth: '1080px',
    },
    '@media (min-width: 1440px)': {
      maxWidth: '1340px',
    },
  },
  content: {
    padding: 0,
    minHeight: 'calc(100vh - 100px)',
  },
}));

export default withFavoriteItems(withProviders(withDisplayData(() => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const { readProviders } = useContext(providersContext);
  const { readFavorites } = useContext(favoriteItemsContext);

  useEffect(() => {
    readProviders();
    readFavorites();
  }, [readProviders, readFavorites]);

  return (
    <Container className={classes.root} maxWidth={false}>
      <Container
        component="section"
        className={classes.content}
        maxWidth={false}
      >
        <Switch>
          <Route component={Provider} path={`${path}/:name`} />
          <Route component={Providers} path={path} />
        </Switch>
      </Container>
    </Container>
  );
})));
